import { initHeroFanCarousel } from './heroSwiper.js';
import { initScrollReveal } from './scrollReveal.js';
import { initDetailsAnimate } from './detailsAnimate.js';
import { initCylinderCarousel }   from './cylinderCarousel.js';

document.addEventListener('DOMContentLoaded', () => {
  initHeroFanCarousel('#lvFan'); // no-op safely on pages without the carousel
  initScrollReveal('.lv-reveal');
  initDetailsAnimate('.lv-details');
  initCylinderCarousel('#lvCylinder');
});